module.exports = __webpack_public_path__ + "static/img/13.8e558e8a.jpg";